import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { saveWorkflowStatus, setSectionsReload, setWorkflowApprover, snackbarMessage, runAfterPromise } from '../../core/actions';
import ConfirmationPopup from '../../core/controls/components/confirmationPopup';
import { GetData, PutData } from '../../core/modules/form/formsapi';
import { getEnvVariable } from '../environmentalList';
import Dropdown from '../../core/controls/components/dropdown';
import Label from '../../core/controls/components/label';
import CommentPopup from '../../core/controls/components/commentpopup';
import { Dialog, DialogTitle } from '@material-ui/core';

var inthis;
const extraProps = {
    transformProps: {
        label: 'name',
        value: 'value'
    },
}

class CWorkflow extends Component {
    constructor(props) {
        super(props);
        //  const { options } = props
        const { WorkflowId, SitePermitTypeId, ApplicationID } = props ? props : { WorkflowId: 0, SitePermitTypeId: 0, ApplicationID: 0 }
        this.state = {
            SitePermitTypeId: SitePermitTypeId,//this.props.apptypeId,
            WorkflowId: WorkflowId,
            // ParentWorkflowId: 0,
            ApplicationID: ApplicationID,//this.props.applicationid,
            // siteID: 0,
            workflowOptions: [],
            workflowStatus: null,
            isApprover: false,
            isAssigned: true,
            currentTaskAssigned: 0,
            workflowStage: '',
            workflowTask: {},
            isForceInspection: false,
            currentStatus: '',
            message: '',
            statusOpen: false,
            prevStatusVal: '',
            comment: null
        }
    }

    componentDidMount() {
        this.getworkflowId();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.WorkflowId !== this.state.WorkflowId)
            this.getworkflowId();
        if (prevState.WorkflowId !== this.state.WorkflowId)
            this.getworkflowId();
        if (this.props.TriggerWorkflowStatus === true && this.props.runAfterPromiseCore === true &&
            this.props.value && (this.props.value !== prevState.prevStatusVal)) {
            this.props.saveWorkflowStatus(false)
            this.props.runAfterPromise(false)
            this.handleSelectChange({ target: { value: this.props.value, name: 'WORKFLOW_STATUS', checked: false } })
        }
        else if (prevProps.workflowreload !== this.props.workflowreload && this.props.workflowreload === true) {
            this.getworkflowId();
            this.props.setSectionsReload(false)
        }
    }

    getworkflowId = () => {
        inthis = this;
        var sourceURL = getEnvVariable('Sidebar') + `/api/Workflows/${inthis.props.ApplicationID}/CurrentWorkflow`;
        GetData(sourceURL, "").then(results => {
            if (results) {
                let workflowId = results.WorkflowId;
                if (workflowId)
                    this.setState({ WorkflowId: workflowId }, () => {
                        this.loadWorkflowObject(workflowId);
                    })
                else this.loadWorkflowObject();
            }
        })
    }

    getworkflowId = () => {
        inthis = this;
        var sourceURL = getEnvVariable('Sidebar') + `/api/Workflows/${inthis.props.ApplicationID}/CurrentWorkflow`;
        GetData(sourceURL, "").then(results => {
            if (results) {
                let workflowId = results.WorkflowId;
                if (workflowId)
                    this.setState({ WorkflowId: workflowId }, () => {
                        this.loadWorkflowObject(workflowId);
                    })
                else this.loadWorkflowObject();
            }
        })
    }

    reload = () => {
        const current = this.props.location.pathname;
        this.props.history.replace(`/reload`);
        setTimeout(() => {
            this.props.history.replace(current);
        });
    }


    loadWorkflowObject(tworkflowId) {
        let tempWorkflowId = tworkflowId ? tworkflowId : inthis.state.WorkflowId
        if (typeof window.workflowObj !== "undefined" && tempWorkflowId && tempWorkflowId > 0) {
            try {        //Verify the workflow access
                console.log("tworkflowId" + tworkflowId + "state tworkflowId" + inthis.state.WorkflowId)

                window.workflowObj.data.getTasks(function (q) {
                    window.workflowObj.data.getFlow(tempWorkflowId, function (retFlow) {
                        var currFlow = retFlow.currflow;
                        if (retFlow && retFlow.isComplete == true) { // Temp code
                            //currFlow.status = "Recommended";
                            //currFlow.isAssigned=false ;
                        }
                        if (q.length === 0) {
                            inthis.setState({ workflowStatus: currFlow ? currFlow.status : '', workflowOptions: currFlow ? currFlow.options : [], isAssigned: currFlow ? currFlow.assignee == inthis.props.accessPermissions.userId : false, WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId }, () => {
                                //inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                            });
                        }
                        else {
                            //From currflow check assigneduserid (userid) and disable workflow dropdown.
                            var currTask = null;
                            for (var i = 0; i < q.length; i++) {
                                var task = q[i];
                                if (task.flowid === (tempWorkflowId && tempWorkflowId.toString())) {
                                    currTask = task;
                                    break;
                                }
                            }
                            if (currTask !== null && currTask.approver) {
                                inthis.props.setWorkflowApprover(true);
                            }
                            if (currTask !== null) {
                                console.log(task.approver, task.investigator, 'task.investigator --- Inspection check');
                                inthis.setState({
                                    workflowTask: currTask,
                                    isApprover: currTask.approver,
                                    isAssigned: currTask.assignee == inthis.props.accessPermissions.userId, //(task.assignee === localStorage.username),//Compare with current loggedin user
                                    workflowStatus: currFlow ? currFlow.status : '',
                                    workflowOptions: currFlow ? currFlow.options : [],
                                    currentTaskAssigned: currTask.assignee,
                                    workflowStage: currFlow ? currFlow.group : '',
                                    isForceInspection: currTask.investigator,
                                    WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId
                                }, () => {
                                    // if (currFlow && currFlow.status)

                                    //inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: currFlow.status, name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                                });
                            } else {
                                //debugger
                                let isApprover = null;
                                let Assignee = 0;
                                let accessPermissionsuser = 0;
                                let xml = retFlow.xml
                                let regexp = /flowable:assignee="([A-Z]*[[a-z]*[0-9]*)" flowable:approver="([A-Z]*[[a-z]*[0-9]*)/g
                                let match = regexp.exec(xml);
                                while (match !== null) {
                                    // matched text: match[0]
                                    // match start: match.index
                                    // capturing group n: match[n]
                                    isApprover = match[2]
                                    Assignee = match[1]
                                    accessPermissionsuser = inthis.props.accessPermissions.userId;
                                    break
                                }
                                if (Assignee == accessPermissionsuser && (isApprover == true || isApprover == 'true') && inthis.props.value === "Recommended") {
                                    inthis.props.setWorkflowApprover(true);
                                }
                                inthis.setState({
                                    workflowStatus: currFlow.status,
                                    isApprover: isApprover,
                                    workflowOptions: currFlow.options,
                                    currentTaskAssigned: currFlow.userid,
                                    workflowStage: currFlow.group,
                                    isAssigned: false,
                                    WorkflowId: tworkflowId ? tworkflowId : inthis.state.WorkflowId
                                }, () => {
                                    inthis && inthis.props && inthis.props.handleFieldValue({ target: { value: currFlow.status, name: 'WORKFLOW_STATUS', checked: false }, currentTarget: { dataset: null } })
                                });
                            }
                        }
                    });
                })
            }
            catch (ex) {
                // this.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false } })
            }
        }
    }

    handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    };



    hasInspection(e) {
        //Check application has any inspection
        var sourceURL = getEnvVariable('Application') + `/api/InspectionSimple/${this.state.ApplicationID}/Grid`;
        GetData(sourceURL, "").then(results => {
            console.log(results);
            if (results && results.data && Array.isArray(results.data) && results.data.length > 0) {
                this.changeWorkflowStatus(e);
            } else {
                inthis.props.snackbarMessage(`Inspection Check : Please add inspection to continue workflow`, 'error');
            }
        })
    }



    changeWorkflowCurrentStatus(tworkflowId) {
        let tempWorkflowId = tworkflowId ? tworkflowId : inthis.state.WorkflowId
        if (typeof window.workflowObj !== "undefined" && tempWorkflowId && tempWorkflowId > 0) {
            try {
                let ApplicationStatusUpdateUrl = ''
                window.workflowObj.data.getTasks(function (q) {
                    window.workflowObj.data.getFlow(tempWorkflowId, function (retFlow) {
                        var currFlow = retFlow;
                        if (currFlow != null) {
                            if (currFlow.isApprover == true) {
                                inthis.props.setWorkflowApprover(true);
                            }
                            if (currFlow.isComplete && currFlow.isComplete === true) {
                                let WorkflowCurrentStatusUpdateUrl = getEnvVariable('Sidebar') + `/api/Workflows/` + inthis.state.ApplicationID + "/" + `UpdateCurrentStatus/` + inthis.state.WorkflowId
                                PutData(WorkflowCurrentStatusUpdateUrl, null).then(rappes => {
                                    inthis.setState({}, () => {
                                        inthis.reload();
                                    })
                                })
                            }
                        }
                    })
                })
            }

            catch (ex) {
                // this.props.handleFieldValue({ target: { value: '', name: 'WORKFLOW_STATUS', checked: false } })
            }
        }
    }

    // handleComment = (c) => {
    //     let e = this.state.openComment
    //     this.setState({ openComment: null, comment: c }, () => {
    //         this.changeWorkflowStatus(e)
    //     })
    // }

    changeWorkflowStatus(e) {
        let workflowChangeObj = { task: this.state.workflowTask, comment: this.state.comment || "No Comment", action: e.target.value }
        //status changed to approved while workflow recommended
        let workflowStatusUpdateUrl = getEnvVariable('Application') + "/api/Application/UpdateWorkflow/" + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + "?&status=" + e.target.value + "&workflowid=" + this.state.WorkflowId;
        if (e.target.value === "Recommended" || e.target.value === "Send Back" || e.target.value === "Not Recommended") {
            if (e.target.value === "Recommended" && this.state.workflowTask.approver === true) {
                let ApplicationStatusUpdateUrl = ""
                if (this.state.workflowTask.approver === true) {
                    inthis.props.setWorkflowApprover(true);
                    ApplicationStatusUpdateUrl = getEnvVariable('Application') + `/api/Application/UpdateStatus/` + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + `?stage=Approved&isUpdateStatus=true`
                }
                else if (this.state.workflowTask.issuer === true) {
                    ApplicationStatusUpdateUrl = getEnvVariable('Application') + `/api/Application/UpdateStatus/` + this.state.SitePermitTypeId + "/" + this.state.ApplicationID + `?stage=Issued&isUpdateStatus=true`
                }
                try {
                    //  workflowChangeObj.task.name = "Investigate";
                    this.props.snackbarMessage(`Please wait Workflow status is changing to ${e.target.value} `, 'info')
                    window.workflowObj.data.complete(workflowChangeObj, function (q) {
                        PutData(workflowStatusUpdateUrl, null).then(res => {
                            if (ApplicationStatusUpdateUrl !== "") {
                                PutData(ApplicationStatusUpdateUrl, null).then(rappes => {
                                    inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                                    inthis.setState({ workflowStatus: e.target.value }, () => {
                                        //inthis.reload();
                                        inthis.props.setSectionsReload(true)
                                        inthis.loadWorkflowObject()
                                    })
                                })
                            }
                            else {
                                inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                                inthis.setState({ workflowStatus: e.target.value }, () => {
                                    // inthis.reload();
                                    inthis.props.setSectionsReload(true)
                                    inthis.loadWorkflowObject()
                                })
                            }

                        }).catch(ex => {
                            // console.log("here workflow excep")
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                //inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                            // inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                        })
                        // inthis.setState({ workflowStatus: e.target.value }, () => {
                        //     inthis.props.setSectionsReload(true)
                        //     inthis.loadWorkflowObject()
                        // })
                    }, function (e) {
                        inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                        inthis.setState({ workflowStatus: e.target.value }, () => {
                            //inthis.reload();
                            inthis.props.setSectionsReload(true)
                            inthis.loadWorkflowObject()
                        })
                        //inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                    });
                } catch (e) { inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error') }

            }
            else {
                try {
                    this.props.snackbarMessage(`Please wait Workflow status is changing to ${e.target.value} `, 'info')
                    window.workflowObj.data.complete(workflowChangeObj, function (q) {
                        PutData(workflowStatusUpdateUrl, null).then(res => {
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                //  inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                        }).catch(ex => {
                            inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                            inthis.setState({ workflowStatus: e.target.value }, () => {
                                //    inthis.reload();
                                inthis.props.setSectionsReload(true)
                                inthis.loadWorkflowObject()
                            })
                            // inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                        })
                        // inthis.setState({ workflowStatus: e.target.value }, () => {
                        //     inthis.props.setSectionsReload(true)
                        //     inthis.loadWorkflowObject()
                        // })
                    }, function (e) {
                        inthis.props.snackbarMessage(`Workflow status changed to ${e.target.value} Successfully`, 'success')
                        inthis.setState({ workflowStatus: e.target.value }, () => {
                            // inthis.reload();
                            inthis.props.setSectionsReload(true)
                            inthis.loadWorkflowObject()
                        })
                        //inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error')
                    });
                } catch (e) { inthis.props.snackbarMessage(`Workflow status failed to  changed to ${e.target.value} `, 'error') }
            }
        }
    }


    handleStatusClose = () => {
        this.setState({ statusOpen: false, currentStatus: "", prevStatusVal: '', message: '' });
    }

    //Permit approver - yes show only label
    //he is recommending, You are the permit approver,recommending will approve this Application - Are u sure u want to recommend
    //  he is not recommend ->You are the permit approver,Not recommending will deny the Application - Are u sure u want to not recommend
    //extender - yes
    //inspection needed - yes


    handleDropdownChange = (e) => {
        let prevVal = this.state.workflowStatus;
        let mgs = this.state.workflowStage === 'Permit Approver' ? `You are the permit approver, ${e.target.value} will ${e.target.value === 'Recommended' ? 'Approve' : "Deny"} Application.` : ""
        this.setState({
            statusOpen: true, prevStatusVal: prevVal, currentStatus: e, message: `${mgs} Are you sure to change the status to ${e.target.value}`
        }, () => {

            if (inthis.state.workflowTask.approver === true)
                inthis.props.saveWorkflowStatus(true);
            inthis.props.runAfterPromise(false)
            inthis.props.handleFieldValue({
                target: { value: e.target.value, name: 'WORKFLOW_STATUS', checked: false },
                currentTarget: { dataset: null },
                extraValues: { WORKFLOW_APPROVER: inthis.state.workflowTask.approver === true ? '1' : '0' }
            })
            // if (inthis.state.workflowTask.approver !== true)
            inthis.handleSelectChange(e);

        });

    }


    handleSelectChange = (e) => {
        if ((e.target.value === "Recommended" ||e.target.value === "Not Recommended") && this.state.isForceInspection)
            this.hasInspection(e);
        else
            this.changeWorkflowStatus(e);
    }


    handleStatusSubmit = () => {
        this.setState({ statusOpen: false, prevStatusVal: '', message: '' }, () => {
            this.handleSelectChange(this.state.currentStatus)
        });
    }

    render() {
        const { edit, value, tooltip } = this.props;
        //const { openComment } = this.state;

        let valueindex = 0;
        let newworkflowoptions = this.state.workflowOptions
        let removedworkflowoptions = ["Waiting", "Forwarded", "Not Forwarded", "Approved", "Denied"]
        if (this.state.workflowOptions && this.state.workflowOptions.length > 0) {
            newworkflowoptions = this.state.workflowOptions.filter(element => {
                if (!removedworkflowoptions.includes(element.name)) {
                    return element
                }
            });
            valueindex = this.state.workflowOptions.findIndex(x => x.value === (this.state.workflowStatus || value));
        }

        return (
            <div className="sketch_ToolBox_Widget">
                {/* <ConfirmationPopup value={this.state.statusOpen || false} onSubmit={this.handleStatusSubmit} onClose={this.handleStatusClose}
                title="Status Change" description={this.state.message || ""} /> */}
                {this.state.WorkflowId && parseInt(this.state.WorkflowId) > 0 ? (<>
                    {!edit ?
                        <Label value={this.state.workflowStatus} extraProps={extraProps} items={newworkflowoptions || []} label={'Workflow Status'} name={'WORKFLOW_STATUS'} changefieldto='DS' /> :
                        <Dropdown className="col-12" extraProps={extraProps} items={newworkflowoptions || []} handleFieldValue={(e) => this.handleDropdownChange(e)} value={this.state.workflowStatus} label={'Workflow Status'} name={'WORKFLOW_STATUS'}
                            disabled={(!this.state.isAssigned)} />
                    }</>) : ''}
                {/* <Dialog open={openComment ? true : false} maxWidth={'sm'} fullWidth={true}>
                    <CommentPopup handleFieldValue={(c) => this.handleComment(c)} />
                </Dialog> */}

            </div>

        );
    }


    componentDidCatch(error, info) {
        console.log(error);
    }
}

const mapProps = state => {
    return {
        TriggerWorkflowStatus: state.header.saveWorkflowStatus,
        workflowreload: state.header && state.header.workflowreload,
        workflowApprover: state.header && state.header.workflowApprover,
        runAfterPromiseCore: state.header && state.header.runAfterPromiseCore,
    }
}

const mapActions = dispatch => {
    return bindActionCreators({ snackbarMessage, setSectionsReload, saveWorkflowStatus, setWorkflowApprover, runAfterPromise }, dispatch);
}

CWorkflow = connect(mapProps, mapActions)(CWorkflow)
export default withRouter(CWorkflow);


//      /*disabled={!this.state.isAssigned} */
/*disabled = {!this.state.isAssigned || this.state.applicationStatus === 30 || this.state.applicationStatus === 50}*/